import React from 'react';
import { toast } from 'react-toastify';
import {
  generatesShortCourseCertificates,
  getUserShortCourses
} from '../../../../../services/apiService';
import { AgGridReact } from 'ag-grid-react';

const pageSize = 15;

// Renders the certificate URL as a link
const CertificateLink = ({ value }) => {
  if (!value) return null;
  return (
<a
    href={value}
  target='_blank'
  rel='noopener noreferrer'
  className='text-blue-600 underline'
    >
    View Certificate
  </a>
);
};

// Renders a button, calls onUpdate with the row data
const UpdateCertificateButton = ({ data, onUpdate }) => (
  <button
    className='px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700'
    onClick={() => onUpdate(data)}
  >
    Update
  </button>
);

const ShortCourses = ({ goalType, userId }) => {
  const [rowsData, setRowsData] = React.useState(null);

  React.useEffect(() => {
    if (!userId) return;
    const fetchTracks = async () => {
      try {
        const data = await getUserShortCourses({userId,goalType});
        setRowsData(data);
      } catch (err) {
        console.error(err);
        toast.error('Failed to fetch data');
      }
    };
    fetchTracks();
  }, [userId]);

  const handleUpdateCertificate = async (row) => {
    // your logic here: open a modal, call an API, etc.
    console.log('Update certificate for', row.courseId);
    await generatesShortCourseCertificates({
      courseId: row.courseId,
      userId
    });
  };

  const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    // headerComponentParams unchanged
  };

  const columnDefs = [
    { field: 'courseId', hide: false },
    { field: 'name', headerName: 'ShortCourse Name' },
    { field: 'progress', headerName: 'ShortCourse Progress' },
    {
      field: 'certificate',
      headerName: 'Certificate',
      cellRenderer: CertificateLink,
    },
    {
      field: 'updateCertificate',
      headerName: 'Update Certificate',
      cellRenderer: UpdateCertificateButton,
      cellRendererParams: { onUpdate: handleUpdateCertificate },
      filter: false,
      sortable: false,
    },
  ];

  return (
    <div className='ag-theme-alpine h-96 w-full'>
      <AgGridReact
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowsData}
        rowSelection='multiple'
        suppressRowClickSelection={true}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={pageSize}
        rowHeight={50}
      />
    </div>
  );
};

export default ShortCourses;